import { useEffect, useState } from "react";
import { securityCheckService } from "../../api";
import { CustomerModel } from "../../models";
import PhotoList from "./photo-list";

export interface SecurityCheckPhotoProps {
    customer: CustomerModel;
}

export default function SecurityCheckPhoto(props: SecurityCheckPhotoProps) {
    const [fileNames, setFileNames] = useState<string[]>([]);

    useEffect(function () {
        (async () => {
            const photo = props.customer.id ? await securityCheckService.envPhoto(props.customer.id!) : [];
            setFileNames(photo);
        })();
    }, [props]);

    return (
        <PhotoList fileNames={fileNames} />
    )
}